import { render, staticRenderFns } from "./LimitProductGeneral.vue?vue&type=template&id=a67c4b6c&scoped=true&"
import script from "./LimitProductGeneral.vue?vue&type=script&lang=js&"
export * from "./LimitProductGeneral.vue?vue&type=script&lang=js&"
import style0 from "./LimitProductGeneral.vue?vue&type=style&index=0&id=a67c4b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c4b6c",
  null
  
)

export default component.exports